export default [
  {
    label: 'Criação',
    value: '1',
  },
]
